module.exports = __webpack_public_path__ + "img/aurora-mobile.0f58a2d3.jpg";